import { ITranslations } from 'types/common';
import { DiscountsTableTransFields } from './types';
import en from 'translations/en/discountsTable.json';
import pl from 'translations/pl/discountsTable.json';
import sl from 'translations/sl/discountsTable.json';

export const discountsTableTranslations: ITranslations<DiscountsTableTransFields> = {
  name: 'discountsTable',
  en,
  pl,
  sl,
};
